<iframe
  [ngClass]="{
    fullscreen: fullscreen
  }"
  style="background-color: white; z-index: 100; width: 100%; height: 100%; border: 0"
  #iframe
  allow="payment"
></iframe>
